export const validate = (values, props) => {
  const errors = {};

  if (!values.from_date) {
    errors.from_date = props.intl.formatMessage({
      id: 'lastMinuteDeals.requiredFromDate',
      defaultMessage: 'From Date is required',
    });
  }

  if (!values.to_date) {
    errors.to_date = props.intl.formatMessage({
      id: 'lastMinuteDeals.requiredToDate',
      defaultMessage: 'To Date is required',
    });
  }

  return errors;
};

export const validateUpdated = (props) => (values) => {
  return validate(values, props);
};

export const cleanValues = (values) => {
  return {
    ...values,
    price: String(values.price) || null,
    title_sv: values.title_sv || null,
    title_de: values.title_de || null,
    title_en: values.title_en || null,
  };
};
